module.exports = __webpack_public_path__ + "img/select-btn_txt.e00ae1fa.png";